import {lazy} from 'react';

const TaxesExemptionViewAsync = lazy(() => import('./TaxesExemptionView'));

export {TaxesExemptionViewAsync};
